import React from 'react';
import { Button } from 'react-bootstrap';

const ArrayActions = ({ fields, index }) => {
  const disabledUp = index === 0;
  const disabledDown = index === fields.length - 1;
  const handleMoveUp = () => {
    if (disabledUp) return;
    fields.swap(index, index -1);
  }
  const handleMoveDown = () => {
    if (disabledDown) return;
    fields.swap(index, index + 1);
  }
  const handleRemove = () => fields.remove(index);
  return (
    <div className="text-right">
      <Button bsStyle="hollow-danger" bsSize="xs" onClick={handleRemove}>
        <span className="ti ti-trash" />
      </Button>
      {' '}
      <Button bsStyle="hollow-info" bsSize="xs" onClick={handleMoveUp}>
        <span className="ti ti-arrow-up" />
      </Button>
      {' '}
      <Button bsStyle="hollow-info" bsSize="xs" onClick={handleMoveDown}>
        <span className="ti ti-arrow-down" />
      </Button>
    </div>
  )
}


export default ArrayActions;



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/ArrayActions.js